import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const CompanyCreateForm = React.lazy(() => loadComponent('orga', 'CompanyCreateForm'))

export function CompanyCreateRoute() {
    const navigate = useNavigate()

    const onCreate = useCallback(() => {
        navigate('/companies')
    }, [navigate])

    const onClose = useCallback(() => {
        navigate('/companies')
    }, [navigate])

    return (
        <RouteContainer>
            <CompanyCreateForm onCreated={onCreate} onClose={onClose} />
        </RouteContainer>
    )
}
